 
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Registramos los componentes de Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function SingleBarChart({ label, value, color = 'rgba(54, 162, 235, 0.6)' }) {
   
  const data = {
    labels: [label],
    datasets: [
      {
        label: label,
        data: [value],
        backgroundColor: color,
      },
    ],
  };

  // Opciones básicas
  const options = {
    indexAxis: 'y',  
    responsive: true,
    plugins: {
      legend: { display: false },  
      title: {
        display: false,
      },
    },
    scales: {
      x: { beginAtZero: true },
    },
  };

  return <Bar data={data} options={options} />;
}

export default SingleBarChart;
